import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ComboBookingManagment {
  apiBaseUrl = environment.apiBaseUrl;

  constructor(private _httpClient: HttpClient) {}

  get(params: { 'page[number]': number, 'page[size]': number, 'orderBy[modifiedOn]': string, 'searchFilter[name]'?: string,'filter[status]':string, }) {
    return this._httpClient.get(`${this.apiBaseUrl}/comboBookings`, { params });
  }

  deleteComboBookingManagment(id: string) {
    return this._httpClient.delete(`${this.apiBaseUrl}/comboBookings/${id}`);
  }

  getComboBookingManagment(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/comboBookings${query}`);
  }

  getComboBookingManagmentById(id: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/comboBookings/${id}`);
  }

  updateComboBookingManagment(id: string, data: any) {
    return this._httpClient.put(`${this.apiBaseUrl}/comboBookings/${id}`, data);
  }

}
